// @ts-nocheck
import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import Typography from "@mui/material/Typography";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Select from "@mui/material/Select";
import Chip from '@mui/material/Chip';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import useRegistrationStore from '@store/registrationStore';
import { useUser, useAuth } from '@/auth/clerkShim';
import { useAdminAuth } from '@/auth/AuthProvider';

import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import './styles.css';
import _, { has } from 'lodash';

const STARTER_DIVISIONS = [
  {
    name: 'Open Division',
  },
  {
    name: 'Upper Division',
  },
  {
    name: 'Recreational Division',
  }
];

const STARTER_PACK = [
  {
    name: 'MENS OPEN',
    divisions: STARTER_DIVISIONS,
  },
  {
    name: 'WOMENS OPEN',
    divisions: STARTER_DIVISIONS,
  }
];

const DEFAULT_PLAYER_FIELD = [
  // {
  //   name: 'Name',
  //   required: true,
  //   helperText: 'Please enter your full name',
  //   include: true
  // },
  {
    name: 'Phone',
    required: false,
    helperText: 'Please enter this players phone number',
    include: false,
    options: [],
    fieldType: 'textbox',
    primitiveType: 'string',
    error: {
      name: '',
      helperText: ''
    }
  },
  {
    name: 'Notes',
    required: false,
    helperText: 'Enter player height, years of experience, etc',
    primitiveType: 'string',
    include: false,
    options: [],
    fieldType: 'textbox',
    error: {
      name: '',
      helperText: ''
    }
  },
  {
    name: 'Shirt Size',
    required: true,
    helperText: 'Please enter this players shirt size',
    primitiveType: 'string',
    fieldType: 'select',
    options: ['S', 'M', 'L', 'XL', 'XXL'],
    include: true,
    error: {
      name: '',
      helperText: ''
    }
  }
];

const NEW_FIELD = {
  name: '',
  required: false,
  helperText: '',
  include: true,
  options: [],
  fieldType: 'textbox',
  primitiveType: 'string',
  error: {
    name: '',
    helperText: ''
  }
};

const CreateTournamentRegistration = ({ season, league }) => {
  const [sections, setSections] = useState(STARTER_PACK);
  const [fields, setFields] = useState(DEFAULT_PLAYER_FIELD);
  const [requirePlayers, setRequirePlayers] = useState(true);
  const [hasPayments, setHasPayments] = useState(false);
  const [deadlineDate, setDeadlineDate] = useState('');
  const [allowCoaches, setAllowCoaches] = useState(false);
  const { addRegistration } = useRegistrationStore();
  const { isSignedIn, user, isLoaded } = useUser();
  const { getToken } = useAuth();
  
  const { admin } = useAdminAuth();
  if (isLoaded) {
    console.log('CreateRegistration::user1', user, admin);
  }
  console.log('CreateRegistration::', fields, requirePlayers, admin);
  console.log('CreateTournamentRegistration::', admin);
  const onSubmit = async () => {
    const token = await getToken();
    console.log('onSubmit::token2', token);
    const fieldList = _.map(_.filter(fields, { include: true }), (field, index) => {
      return {
        ...field,
        order: index + 1
      };
    });
    const returnObject = {
      league: admin?.league?._id,
      admin: admin?._id,
      fields: _.filter(fields, { include: true }),
      requirePlayers,
      hasPayments,
      contestType: 'tournament',
      allowCoaches,
      deadlineDate: deadlineDate ? deadlineDate?.format('MM/DD/YYYY') : null,
    };
    console.log('returnObject::', returnObject);
    console.log('onSubmit::', fields, requirePlayers, hasPayments);
    debugger;
    addRegistration(returnObject, token);
  };

  return (
    <div>
      Create Tournament Registration
      <br />
      <TextField
        label={'Message/Notes to Team Managers'}
        helperText={'Let team managers know any important information to include '}
        multiline
        rows={2}
        maxRows={4}
        />
      <br />
      <br />
      <Typography variant="subtitle1">Registration Deadline:</Typography>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        {/* <DatePicker value={deadlineDate} onChange={(v) => setDeadlineDate(v)} /> */}
      </LocalizationProvider>
      <br />
      <br />
      <Typography variant="subtitle1">Include Payments</Typography>
      <RadioGroup
        aria-label="include players"
        name="includePlayers"
        className={'group'}
        value={hasPayments}
        onClick={e => setHasPayments(e.target.value === 'true')} >
        <FormControlLabel  value={true} control={<Radio />} label={'Yes'} />
        <FormControlLabel  value={false} control={<Radio />} label={'No'} />
      </RadioGroup>
      <br />
      <br />
      <Typography variant="subtitle1">Allow Coaches</Typography>
      <RadioGroup
        aria-label="include coaches"
        name="allowCoaches"
        className={'group'}
        value={allowCoaches}
        onClick={e => setAllowCoaches(e.target.value === 'true')} >
        <FormControlLabel  value={true} control={<Radio />} label={'Yes'} />
        <FormControlLabel  value={false} control={<Radio />} label={'No'} />
      </RadioGroup>
      <br />
      <br />
      <Typography variant="subtitle1">Include Players:</Typography>
      <RadioGroup
        aria-label="include players"
        name="includePlayers"
        className={'group'}
        value={requirePlayers}
        
        onClick={e => setRequirePlayers(e.target.value === 'true')} >
        <FormControlLabel value={true} control={<Radio />} label={'Yes'} />
        <FormControlLabel value={false} control={<Radio />} label={'No'} />
      </RadioGroup>
      <h3>Player Fields</h3>
      <br />
      {requirePlayers ? (
      <div>
        <div className="field-group">
          <div className="header">Field Name</div>
          <div className="header">Helper Text</div>
          <div className="header">Field Type</div>
          <div className="header">Required</div>
          <div className="header">Include</div>
        </div>
        <div className="field-group">
          <div style={{ textAlign: 'center', alignSelf: 'center' }}>Player Name</div>
          <div style={{ textAlign: 'center', alignSelf: 'center' }}>Enter player name</div>
          <div style={{ textAlign: 'center', alignSelf: 'center' }}>Textbox</div>
          <div style={{ textAlign: 'center', alignSelf: 'center' }}>X</div>
          <div style={{ textAlign: 'center', alignSelf: 'center' }}>X</div>
        </div>
          {fields.map((field, index) => {
            return (
              <>
              <div className="field-group">
            <TextField
              label={'Field Name'}
              error={field.error.name}
              variant="outlined"
              value={field.name}
              disabled={!field.include}
              helperText={field.error.name || ''}
              onChange={(e) => {
                const newFields = [...fields];
                newFields[index].name = e.target.value;
                if (!e.target.value) {
                  newFields[index].error.name = 'Field name is required';
                } else {
                  newFields[index].error.name = '';
                }
                setFields(newFields);
              }}
            />
            <TextField
              label={'Helper Text'}
              error={field.error.helperText}
              style={{ width: '350px' }}
              variant="outlined"
              value={field.helperText}
              maxLength={50}
              disabled={!field.include}
              helperText={field.error.helperText || ''}
              onChange={(e) => {
                const newFields = [...fields];
                newFields[index].helperText = e.target.value;
                if (!e.target.value) {
                  newFields[index].error.helperText = 'Helper text is required';
                } else {
                  newFields[index].error.helperText = '';
                }
                setFields(newFields);
              }}
            />
            <Select
              native
              value={field.fieldType}
              disabled={!field.include}
              onChange={(e) => {
                const newFields = [...fields];
                newFields[index].fieldType = e.target.value;
                setFields(newFields);
              }}
            >
              <option value={'textbox'}>Textbox</option>
              <option value={'select'}>Select</option>
            </Select>
            <Checkbox
              native
              value={field.required}
              disabled={!field.include}
              onChange={(e) => {
                const newFields = [...fields];
                console.log('onChange::', e.target.checked);
                newFields[index].required = e.target.checked;
                console.log('onChange2::', newFields[index]);
                setFields(newFields);
              }}
              checked={field.required}
              />
            <Checkbox
              native
              value={field.include}
              onChange={(e) => {
                const newFields = [...fields];
                console.log('onChange::', e.target.checked);
                newFields[index].include = e.target.checked;
                console.log('onChange2::', newFields[index]);
                setFields(newFields);
              }}
              checked={field.include}
              />
              </div>
              {field.fieldType === 'select' && (<div key={index} style={{ margin: '5px 0px'}}>
                <TextField
                  label={'Option Name'}
                  variant="outlined"
                  value={field.newOption}
                  onChange={(e) => {
                    const newFields = [...fields];
                    newFields[index].newOption = e.target.value;
                    setFields(newFields);


                  }}
                />
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    const newFields = [...fields];
                    newFields[index].options = [...newFields[index].options, newFields[index].newOption];
                    newFields[index].newOption = '';
                    setFields(newFields);
                  }}
                >
                  +
                </Button>
              </div>)}
              <div>
                {field.options?.map((option, jindex) => {
                  return (
                    <Chip
                      key={jindex}
                      label={option}
                      onDelete={() => {
                        const newFields = [...fields];
                        newFields[index].options.splice(jindex, 1);
                        setFields(newFields);
                      }}
                    />
                  );
                })}
              </div>
              <br />
              <br />
              </>
            )
          })}

        </div>
    ) : null}
      <br />
      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          setFields([...fields, _.cloneDeep(NEW_FIELD, true)]);
        }}
      >
        Add Field
      </Button>
      <br />
      <h3>Brackets (Can be added later)</h3>
      <br />
      {sections.map((section, index) => {
        return (
          <div>
            <div key={index} style={{ margin: '5px 0px'}}>
              <TextField
                label={'Section Name'}
                variant="outlined"
                value={section.name}
                onChange={(e) => {
                  const newSections = [...sections];
                  newSections[index].name = e.target.value;
                  setSections(newSections);
                }}
              />
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  const newSections = [...sections];
                  newSections.splice(index, 1);
                  setSections(newSections);
                }}
              >
                X
              </Button>
            </div>
            <h3>Divisions (Can be added later)</h3>
            <div style={{ margin: '0 0 20px 50px' }}>
              {section.divisions.map((division, jindex) => {
                return (
                  <div key={jindex} style={{ margin: '5px 0px'}}>
                    <TextField
                      label={'Division Name'}
                      variant="outlined"
                      value={division.name}
                      onChange={(e) => {
                        const newSections = [...sections];
                        const newDivisions = [...section.divisions];
                        newDivisions[jindex].name = e.target.value;
                        newSections[index].divisions = newDivisions;
                        setSections(newSections);
                      }}
                    />
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        const newSections = [...sections];
                        const newDivisions = [...section.divisions];
                        newDivisions.splice(jindex, 1);
                        newSections[index].divisions = newDivisions;
                        setSections(newSections);
                      }}
                    >
                      X
                    </Button>
                  </div>
                )
              })}
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  const newSections = [...sections];
                  newSections[index].divisions = [...section.divisions, { name: '' }];
                  setSections(newSections);
                }}
              >
                Add Division
              </Button>
            </div>

          </div>
        )
      })}
      <br />
      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          setSections([...sections, { name: '', divisions: STARTER_DIVISIONS }]);
        }}
      >
        Add Section
      </Button>
      <br />
      <br />
      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          onSubmit();
        }}
      >
        Submit2
        </Button>
    </div>
  );
};

export default CreateTournamentRegistration;